import { Outlet } from 'react-router-dom';
import { IChildrenProp } from 'types/components/components.interface';
import { TopbarPage } from '..';

interface ITopbarTabsTemplateProps extends IChildrenProp {
  topbarAbsolute?: boolean;
}

const TopbarTabsTemplate = ({ children, topbarAbsolute = true }: ITopbarTabsTemplateProps) => {
  return (
    <TopbarPage className="topbar-tabs" topbarAbsolute={topbarAbsolute} topbar={children}>
      <Outlet />
    </TopbarPage>
  );
};

export default TopbarTabsTemplate;
